import React from 'react'
import {
  BoxContainer,
  Divider,
} from './style/QuestionAnswerBox.css'
import QuestionAnswerHeader from './QuestionAnswerHeader'
import QuestionAnswerBody from './QuestionAnswerBody'
import QuestionAnswerFooter from './QuestionAnswerFooter'

export default function QuestionAnswerBox({
  data,
  Link,
  formatBrandInText,
  isBot,
}) {
  return (
    <BoxContainer>
      <QuestionAnswerHeader
        productUrl={data.productUrl}
        imageUrl={data.imageUrl}
        formatBrandInText={formatBrandInText}
        skuTitle={data.skuTitle}
        Link={Link}
        price={data.price}
        isBot={isBot}
      />
      <QuestionAnswerBody
        questionAuthor={data.questionAuthor}
        questionText={data.questionText}
        answerAuthor={data.answerAuthor}
        answerText={data.answerText}
      />
      <Divider>
          &nbsp;
      </Divider>
      <QuestionAnswerFooter
        numberOfQuestions={data.numberOfQuestions}
        numberOfAnswers={data.numberOfAnswers}
        productUrl={data.productUrl}
        Link={Link}
      />
    </BoxContainer>
  )
}
